import type { ReactElement } from 'react';
import React from 'react';
import UserIcon from 'feature-components/reports/stanine-report/user-icon/user-icon';
import type { BaseGender } from 'services/assist-api/entities/gender/genders';
import './footer-legend.scss';

type Props = {
  genders: readonly BaseGender[];
  studentsPerIcon: number;
};

// This component controls text underneath a stanine report table
// it is tightly coupled with users-widget component
export default function StanineFooterLegend({ genders, studentsPerIcon }: Props): ReactElement {
  return (
    <div className="stanine-table-footer-legend">
      Stanine Distribution ({' '}
      {genders.length ? (
        genders.map((g) => {
          const genderColor = g.name;

          return (
            <span key={`genderId-${g.id}`}>
              <UserIcon genderColor={genderColor} /> = {studentsPerIcon} {genderColor}{' '}
            </span>
          );
        })
      ) : (
        <span>
          <UserIcon /> = {studentsPerIcon} student{' '}
        </span>
      )}
      )
    </div>
  );
}
